import { render, staticRenderFns } from "./ButtonReturn.vue?vue&type=template&id=4ef77443&scoped=true"
import script from "./ButtonReturn.vue?vue&type=script&lang=js"
export * from "./ButtonReturn.vue?vue&type=script&lang=js"
import style0 from "./ButtonReturn.vue?vue&type=style&index=0&id=4ef77443&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef77443",
  null
  
)

export default component.exports